import React, { useState } from "react";

const FilterToken = ({ selectedToken, onSelectToken }) => {
  const tokenOptions = [
    { value: "Gold", label: "Gold" },
    { value: "Silver", label: "Silver" },
    { value: "Bronze", label: "Bronze" },
  ];

  return (
    <div className="pb-2 ml-3 mb-2 relative flex items-center">
      <select
        id="token"
        value={selectedToken}
        onChange={onSelectToken}
        className="border border-gray-300 bg-white w-24 text-xs text-grey-700 py-1 pl-3 pr-3 leading-tight rounded-lg focus:outline-none"
      >
        <option value="" hidden>
          Select the category
        </option>
        {tokenOptions.map((option) => (
          <option key={option.value} value={option.value} >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FilterToken;
